import(/* webpackMode: "eager" */ "/vercel/path0/components/StatPageClient.tsx")